import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { Api, JsonRpc, RpcError, JsSignatureProvider } from 'eosjs';
var appRoot = document.getElementById('root');
const Eos = require('eosjs');
var matches;
var predictions = [];
var privateKey = "";
var username = "";
var contractName;
var chainId;
var httpEndpoint;
var chain = {
     main: 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906', // main network
     jungle: 'e70aaab8997e1dfce58fbfac80cbbb8fecec7b99cf982a9444273cbc64c41473', // jungle testnet
     sys: 'cf057bbfb72640471fd910bcb67639c22df9f92470936cddc1ade0e2f2e7dc4f' // local developer
   };

var matches = [
  {homeTeam:"WHU", awayTeam: "ARS", time:1547296200, prediction: null },
  {homeTeam:"BRI", awayTeam: "LIV", time:1547305200, prediction: null  },
  {homeTeam:"BUR", awayTeam: "FUL", time:1547305200, prediction: null  },
  {homeTeam:"CAR", awayTeam: "HUD", time:1547305200, prediction: null  },
  {homeTeam:"CRY", awayTeam: "WAT", time:1547305200, prediction: null  },
  {homeTeam:"LEI", awayTeam: "SOU", time:1547305200, prediction: null  },
  {homeTeam:"CHE", awayTeam: "NEW", time:1547314200, prediction: null  },
  {homeTeam:"EVE", awayTeam: "BOU", time:1547388900, prediction: null  },
  {homeTeam:"SPU", awayTeam: "MUN", time:1547397000, prediction: null  },

];

let params = (new URL(document.location)).searchParams;
let network = params.get("network");
let referral = params.get("referral") || "accountbadla";
console.log(referral);
if(network=='jungle'){
 chainId = chain.jungle;
 contractName = "eoslottotest";
 httpEndpoint = "https://jungle2.cryptolions.io:443";
} else {
    chainId = chain.main;
    contractName = "accountbadla";
    httpEndpoint='https://api.eosnewyork.io:443';
}

var eos = Eos({
  httpEndpoint: httpEndpoint,
  chainId: chainId,
});

var options;
var pubkey;
const $ = window.$;
const moment = window.moment;

if (window) {
  window.addEventListener('unhandledrejection', function (event) {
      updateBetProgress("assets/img/error.png", "Sorry, something went wrong. Please ensure your keys are valid, you have enough balance and you are not betting multiple times.<br/>");
  });
}

function showalert(message, alerttype) {

    $('#alert_placeholder').append('<div id="alertdiv" className="alert ' + alerttype + '"><a className="close" data-dismiss="alert">×</a><span>' + message + '</span></div>')
    setTimeout(function() { // this will automatically close the alert and remove this if the users doesnt close it in 5 secs
        $("#alertdiv").remove();
    }, 3000);
}


function eosLogin() {

    eos = Eos({
        keyProvider: privateKey, // private key
        httpEndpoint: httpEndpoint,
        chainId: chainId
    });
    options = {
        authorization: username + '@active',
        broadcast: true,
        sign: true
    };
    pubkey = Eos.modules.ecc.privateToPublic(privateKey);
    makeBet();

}

function getAccountInfo(accountName) {
    eos.getAccount(accountName).then(result => console.log(result)).catch(error => console.error(error));
}

function fetchWinners() {
    eos.getTableRows({ json: true, code: contractName, json: true, scope: contractName, table: "winners", limit: 1000 }).then(r => {
        console.log(r.rows[0].user);
        var winner = r.rows[0].user;
    });
}

$(window).ready(function(){


$('#tutorial').click(function(){
    $("#tutorialModal").modal();
});

$('#referral').click(function(){
    $("#referralModal").modal();
});

$('#referralurl').text(window.location.href.toLowerCase()+"?referral=youreosaccount");


 $('#loginButton').click(function(){
   keyAdded();
 });

});

function showLogin(){
  $("#inputKey").modal();
}


function keyAdded(){
  privateKey = $('#keyInput').val();
  username = $('#username').val();
  $("#inputKey").modal('hide');
  eosLogin();
}

function PredictionSlot(props) {
  var cellStyle={
    "backgroundColor":props.value,
  }
  return <td style={cellStyle} onClick={props.onClick}> </td>
}


class MatchSlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slots : [0 , 0, 0]
    }
  }

  componentWillMount() {
    this.setPrediction(this.props.prediction-1);
  }

  setPrediction(i) {
    var slots = [0, 0, 0];
    slots[i]=1
    this.setState({slots:slots});
    predictions[this.props.match_key] = i;
  }

  draw(selected){
    //return selected? '#ccff18' : '#fff200';
    return selected? '#9c27b0' : '#ffffff';
  }

  render() {
    return (
    <tr>
        <td><i className="fa fa-calendar"> </i> {moment.unix(this.props.time).format("MMMM D - hh:mm A")}</td>
        <td><img src={"assets/img/"+this.props.homeTeam+".png"} height="25px" /> {this.props.homeTeam}</td>
        <td><img src={"assets/img/"+this.props.awayTeam+".png"} height="25px" /> {this.props.awayTeam}</td>

      {!this.props.isAdmin && this.state.slots.map((selected, i) =>
         <PredictionSlot
           key={i}
           value={this.draw(selected)}
           onClick={() => this.setPrediction(i)}
          />
      )}
      {this.props.isAdmin &&
      <td style={{backgroundColor:'#212529'}}>
       <button  onClick={() => this.props.removeMatch(this.props.match_key)} type="button" className="btn btn-sm btn-danger">DELETE</button>
      </td>
      }
    </tr>
    )
  }
}

function updateBetProgress(imagesrc,text){
  var image = $("#progressImage");
  image.attr('src', imagesrc);
  /*image.fadeOut('slow', function () {

        image.fadeIn('slow');
  });*/
  $("#progressStatus").html(text);
}

function checkPredictions(){
  console.log(predictions.length);
  for(var i=0;i<predictions.length;i++){
    if(predictions[i]==-1)
    return true;
  }
  return false;
}

function makeBet() {
  console.log(predictions);
  if(checkPredictions()){
    $("#betProgress").modal();
    updateBetProgress("assets/img/error.png", "Please select all predictions");
    return;
  }

  $("#betProgress").modal();
  //$('#lottoprogressbar').css('width', 10+'%').attr('aria-valuenow', 10);
  //$('#lottoprogresstext').html("<i className='fa fa-clock-o'></i>  Please wait, while the bets are being placed..")
  updateBetProgress("assets/img/waiting.png", "Please wait, while the bets are being placed");
  console.log(predictions[0]);
    eos.contract(contractName).then((contract) => {

        //$('#lottoprogressbar').css('width', 40+'%').attr('aria-valuenow', 40);
        //$('#lottoprogresstext').html("<i className='fa fa-shield'></i> Getting the required permissions..")
        updateBetProgress("assets/img/permissions.png", "Getting the required permissions");


         eos.updateauth({
                "account": username,
                "permission":"active",
                "parent":"owner",
                "auth":{
                    "keys":[{
                        "key": pubkey,
                        "weight":1
                    }],
                    "threshold":1,
                    "accounts":[{
                        "permission": {
                            "actor": contractName,
                            "permission":"eosio.code"
                        },
                        "weight":1
                    }],
                    "waits":[]
                }
            }, {
                authorization: username+"@active"
            }).then(result => {
            updateBetProgress("assets/img/payment.png", "Sending 0.5 EOS to the contract");

              //$('#lottoprogressbar').css('width', 80+'%').attr('aria-valuenow', 80);
              //$('#lottoprogresstext').html("<i className='fa fa-hourglass-start'> </i> Sending 0.5 EOS to the contract...");
              console.log("predictions");
              console.log(predictions);
              contract.placebet({user:username,bet:"0.5000 EOS",predictions:predictions, referral: referral}, { authorization: [{
                  actor: username,
                  permission: 'active'
                }] }).then(result => {console.log(result);
              updateBetProgress("assets/img/placed.png", "Your bet has been placed");

                //  $('#lottoprogressbar').css('width', 100+'%').attr('aria-valuenow', 100);
                  //$('#lottoprogresstext').html("<i className='fa fa-thumbs-o-up'></i> Bets placed successfully");
                   })
              })

      }).catch((err) => { console.log('ouch') });

    }



class UserTableHeader extends React.Component {

  render() {
    return (
      <tr>
        <th scope="col">Kick Off</th>
        <th scope="col">Home Team</th>
        <th scope="col">Away Team</th>
        <th scope="col">Home </th>
        <th scope="col">Away </th>
        <th scope="col">Draw</th>
       </tr>
    )
  }
}

class AdminTableHeader extends React.Component {

  render() {
    return (
      <tr>
        <th scope="col">Kick Off</th>
        <th scope="col">Home Team</th>
        <th scope="col">Away Team</th>
        <th scope="col">Action</th>
       </tr>
    )
  }
}


class MatchTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            matches: []
        }
        this.loggedIn = this.loggedIn.bind(this);
    }

    fetchMatches() {
      //  matches = [];
        var self = this;


        this.setState({matches:matches});
        /*
        eos.getTableRows({json:true, code: contract, json:true, scope: contract, table: "games", limit:1000}).then(r => {
            for (var i = 0; i < r.rows.length; i++) {
            matches.push({
              homeTeam:r.rows[i].home_team,
              awayTeam: r.rows[i].away_team,
              time: r.rows[i].match_time,
              prediction: null
            });
            self.setState({
              matches: matches
            });
            }
          });*/
    }

    updatePrediction(key, prediction) {
    /*  this.setState({
        matches: update(this.state.matches, {key: {prediction: {$set: prediction}}})
     });*/
    }

    componentWillMount() {
        if (!this.props.isAdmin)
        this.setState({matches:[]});
         //this.fetchMatches();
    }

    removeMatch(i) {
      matches = this.state.matches;
      matches.splice(i,1);
      this.setState({matches:matches});
    }

    loggedIn(event){
      if (!this.props.isAdmin)
      this.fetchMatches();
    }

    matchAdded(event){
      matches = this.state.matches;
      var match = event.detail;
      matches.push(match);
      this.setState({matches:matches});
    }

    async componentDidMount(){
      this.fetchMatches();
    //  window.addEventListener('loggedIn', this.loggedIn);
    }

    componentWillUnMount(){
      //window.removeEventListener('loggedIn', this.loggedIn);
    }

    render() {

      return (

          <table className="table">
            <thead >
              { this.props.isAdmin &&
                 <AdminTableHeader />
              }
              { !this.props.isAdmin &&
                 <UserTableHeader />
              }
            </thead>
            <tbody>
              {  this.state.matches.map((match, i) =>
                   <MatchSlot
                       key={i}
                       prediction={match.prediction}
                       time={match.time}
                       homeTeam={match.homeTeam}
                       awayTeam={match.awayTeam}
                       match_key={i}
                       isAdmin={this.props.isAdmin}
                       removeMatch={this.removeMatch}
                   />
              )}
            </tbody>
          </table>

    );

    }

}


class App extends Component {
  render() {
    return (
       <div >
      <div className="main main-raised">
    <div className="container">
      <div id="game" className="section text-center">
        <div className="row">
          <div  className="col-md-12 ml-auto mr-auto">
          <h2 className="title"><i className='fa fa-futbol-o'> </i> EPL Matches</h2>
<br/>

        <MatchTable
          isAdmin={false}
        />
        <br/>
      <br/><br/>

  <a onClick={()=> showLogin()} target="_blank" style={{color:"white"}} className="btn btn-danger btn-raised btn-lg">
    <i className="fa fa-diamond"></i> Bet 0.5 EOS
  </a>
 <br/> <small> Draw will be held on Jan 14, 2019 </small> <br/>
<small> Please ensure your wallet doesn't need specific memos to receive EOS </small>
       <br/><br/>    <div id = "alert_placeholder"></div>






          <div className="modal" id="winners" tabIndex="-1" role="dialog" style={{color:'black'}}>
                              <div className="modal-dialog" role="document" >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <center >
<iframe src="https://giphy.com/embed/FgboyOLK5RSz6" width="344" height="480" frameBorder="0" className="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/football-FgboyOLK5RSz6"></a></p>
                                     <h2 id="winner_name"> </h2> </center>

                                  </div>

                                </div>
                              </div>
                            </div>

      </div>
    </div>
  </div>


</div>

</div>




  </div>
    );
  }
}

export default App;
